import { cn } from '@/_lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
	return (
		<div
			data-slot='skeleton'
			className={cn('animate-pulse bg-gray-100 dark:bg-gray-200', className)}
			{...props}
		/>
	)
}

export { Skeleton }
